import React, {useState,useEffect} from 'react'
import './StudentClassStudentAdminPage.css'
import apiClient from '../api/apiClient'
import {useAuth} from '../context/AuthContext'

export default function StudentTestGroupAdminPage(){
    const {user} = useAuth()
    const schoolID = user.scId

    const [studentClasses, setStudentClasses] = useState([])
    const [currentAssignFromStudentClass, setCurrentAssignFromStudentClass] = useState(null)
    const [dragOverActive, setDragOverActive] = useState(false)
    const [assignableStudents, setAssignableStudents] = useState([])
    const [assignToTestGroup, setAssignToTestGroup] = useState(null)
    const [testGroups, setTestGroups] = useState(null)
    const [assignToStudents, setAssignToStudents]= useState([])
    const [studentAssigned, setStudentAssigned] = useState(0)

    async function fetchAllStudentClasses(){
        try{
            const result = await apiClient.get('/api/studentclass/getall', 
                {params: {schoolID: schoolID}}
            )
            setStudentClasses(result.data)
        }catch(e){
            console.log("fejl ved hent af kursushold")
            console.log(e)
        }

    }
    async function fetchAssignableStudents(){
        try{
            const results = await apiClient.get('/api/students/getassignabletotestgroup',{
                params: {
                    currentStudentClassID : currentAssignFromStudentClass?.id || null, 
                }
            })
            setAssignableStudents(results.data)
        }catch(e){
            console.log("fejl i get assignable students")
            console.log(e)
        }
    }

    async function fetchTestGroups(){
        console.log("fetghing prøvegrupper")
        try{
            const result = await apiClient.get('/api/testgroup/getall',
                {params: {schoolID: schoolID}}
            )
            setTestGroups(result.data)
        }catch(e){
            console.log("error fetcht prøvegrupper")
            console.log(e)
        }
    }

    async function fetchStudentsInTestGroup(){
        console.log("getting kursister i prøvegruppe")
        try{
            const result = await apiClient.get('/api/testgroup/getstudentsintestgroup',
                {params : {testGroupID: assignToTestGroup?.id || null}}
            )
            setAssignToStudents(result.data)

        }catch(e){
            console.log("error in getting kursister i prøvegruppe")
            console.log(e)
        }
    }

    useEffect(()=>{
        fetchAllStudentClasses()
        fetchAssignableStudents()
        fetchTestGroups()
        fetchStudentsInTestGroup()
    },[studentAssigned, currentAssignFromStudentClass, assignToTestGroup])


    function handleDragOver(e){
        e.preventDefault()
        setDragOverActive(true)
    }

    function handleDragLeave(){
        setDragOverActive(false)
    }

    async function handleDropStudentClass(e, studentClass){
        e.preventDefault()
        console.log("dropper i kursushold")
        setDragOverActive(false)
        const studentID = e.dataTransfer.getData('studentid')
        await apiClient.post('/api/testgroup/assignstudenttotestgroup',
            {studentID: studentID, testGroupID: null}
        )
        setStudentAssigned(p=>p+1)
    }

    async function handleDropTestGroup(e, testGroup){
        e.preventDefault()
        setDragOverActive(false)
        console.log("dropper i test group")
        const studentID = e.dataTransfer.getData('studentid')
        await apiClient.post('/api/testgroup/assignstudenttotestgroup',
            {studentID: studentID, testGroupID: testGroup.id}
        )
        setStudentAssigned(p=> p+1)
    }


    function handleDragStart(e, kursist){
        e.dataTransfer.setData('studentid', kursist.id.toString())
    }

    return(
        <div className="panel-container">
            <div className="panel">
                <select onChange={(e)=>setCurrentAssignFromStudentClass(studentClasses.find(s=> s.id === parseInt(e.target.value)))}>
                    <option key="0" value={null}>Intet hold</option>
                    {studentClasses.map(studentClass=>{
                        return(
                            <option key={studentClass.id} value={studentClass.id}>{studentClass.holdnavn}</option>
                        )
                    })}
                </select>
                <span>
                    <b>Holdnavn: </b> {currentAssignFromStudentClass?.holdnavn}
                    <b>Studieretning: </b> {currentAssignFromStudentClass?.studieretning}
                </span>
                <div className =  {`drop-zone ${dragOverActive? 'dropzone-active': ''}`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={(e)=>handleDropStudentClass(e, currentAssignFromStudentClass)}
                    >
                    
                    {assignableStudents.length ===0 ? (
                        <p className="drop-zone-hint">Træk en kursist hertil</p>
                    ): (
                        <table className="censor-table">
                            <thead>
                                <tr>
                                    <th style={{width: '30%'}}>Fornavn(e)</th>
                                    <th style={{width: '30%'}}>Efternavn</th>
                                    <th style={{width: '20%'}}>Studie</th>      
                                </tr>
                            </thead>
                            <tbody>
                                {assignableStudents.map(s => (
                                        <tr 
                                            key={s.id}
                                            draggable
                                            onDragStart={(e) => handleDragStart(e,s)}
                                            className="draggable-row">
                                            <td>{s.fornavne}</td>
                                            <td>{s.efternavn}</td>
                                            <td>{s.studie}</td>

                                        </tr>
                                    )
                                )}
                                {assignableStudents.lenght ===0 &&
                                <tr>
                                    <td colSpan="3" style={{textAlign:'center', padding:'2rem', color:'#888'}}>
                                        Ingen kursister 
                                    </td>
                                </tr>}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

            <div className="panel">
                <div className="panel">
                    <select onChange={(e)=>setAssignToTestGroup(testGroups.find((t)=> t.id === parseInt(e.target.value)))}>
                        <option key="0">Ingen prøvegruppe valgt</option>
                        {testGroups && testGroups.map(tg => {
                            return(
                                <option key={tg.id} value={tg.id}>{tg.navn}</option>
                            )
                        })}
                    </select>
                    <span>
                        <b>Prøvegruppe: </b> {assignToTestGroup?.navn}
                    </span>
                    <div className={`drop-zone ${dragOverActive? 'dropzone-active' : ''} `}
                        onDragOver ={handleDragOver}
                        onDragLeave ={handleDragLeave}
                        onDrop ={(e)=>handleDropTestGroup(e,assignToTestGroup)}
                    >
                    {assignToStudents?.length === 0 ? (
                        <p className="drop-zone-hint">Træk en kursist hertil</p>
                    ):(
                        <table className="censor-table">
                            <thead>
                                <tr>
                                    <th>Fornavn(e)</th><th>Efternavn</th><th>Studie</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignToStudents.map(student =>{
                                    return(
                                        <tr key={student.id}
                                            draggable
                                            onDragStart ={(e)=>handleDragStart(e,student)}
                                            className="draggable-row"
                                            >
                                            <td>{student.fornavne}</td><td>{student.efternavn}</td><td>{student.studie}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>

                    )}
                    </div>
                </div>
            </div>
        </div>
    )
    
}